import React from 'react';
import PropTypes from 'prop-types';

const Download = ({ fill = '' }) => (
  <svg
    width="11px"
    height="14px"
    viewBox="0 0 11 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Payment-Links---Ordres-Copy-14"
        transform="translate(-1358.000000, -322.000000)"
        fill={fill || '#FFFFFF'}
        fillRule="nonzero"
      >
        <g id="Group-8" transform="translate(265.000000, 257.000000)">
          <g id="Group" transform="translate(0.000000, 48.000000)">
            <g id="Group-5" transform="translate(1081.000000, 10.000000)">
              <g id="Group" transform="translate(12.000000, 7.000000)">
                <path
                  d="M4.20525063,11.5804105 L4.31808467,11.6590763 L4.43707332,11.7193412 L4.52241849,11.7498341 L4.60982165,11.7716934 L4.6988507,11.7849134 C4.75909502,11.7908518 4.81985666,11.7908518 4.88015863,11.7849077 L4.95289889,11.7745368 L5.05679143,11.7497559 L5.18259492,11.7007871 L5.2838636,11.6452617 L5.37369595,11.5804146 L5.43517227,11.525179 L9.30918521,7.651284 C9.66887385,7.29159536 9.66887385,6.70840464 9.30918521,6.348716 L9.2343999,6.28157413 C8.87273115,5.99062598 8.34232661,6.01300661 8.00661722,6.348716 L5.70998592,8.64463158 L5.71050689,0.921043997 C5.71050689,0.412362609 5.29814428,9.16226159e-15 4.78946289,9.16226159e-15 L4.69529103,0.00475521518 C4.23084697,0.0519215713 3.86841889,0.444155195 3.86841889,0.921043997 L3.86788065,8.64389474 L1.57233447,6.348716 C1.21264583,5.98902737 0.629455115,5.98902737 0.269766478,6.348716 C-0.0899221593,6.70840464 -0.0899221593,7.29159536 0.269766478,7.651284 L4.13849062,11.5199822 C4.17166138,11.5519629 4.17166138,11.5519629 4.20525063,11.5804105 Z"
                  id="Path"
                />
                <path
                  d="M8.65787531,12.1578861 L0.921050473,12.1578861 C0.412369085,12.1578861 6.47615129e-06,12.5702487 6.47615129e-06,13.0789301 C6.47615129e-06,13.5876111 0.412368685,14 0.921050473,14 L8.65790121,14 C9.1665826,14 9.57894521,13.5876374 9.57894521,13.078956 C9.57894521,12.5702746 9.1665567,12.1578861 8.65787531,12.1578861 Z"
                  id="Path"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Download.propTypes = {
  fill: PropTypes.string,
};

export default Download;
